import { Component, input, output } from '@angular/core';

@Component({
  selector: 'app-etapas-servico',
  templateUrl: './etapas-servico.component.html',
  styleUrls: ['./etapas-servico.component.css'],
  host: {
    // A grade acompanha a quantidade real de etapas, para nenhuma delas quebrar de linha.
    '[style.--etapas-total]': 'etapas().length',
  },
})
export class EtapasServicoComponent {
  readonly etapas = input.required<readonly string[]>();

  readonly etapaAtual = input.required<number>();

  readonly etapaLiberada = input.required<number>();

  readonly mensagemBloqueio = input('Conclua a etapa anterior para liberar');

  readonly selecionar = output<number>();

  situacaoDaEtapa(indice: number): 'concluida' | 'andamento' | 'bloqueada' | 'aguardando' {
    if (indice < this.etapaAtual()) return 'concluida';
    if (indice === this.etapaAtual()) return 'andamento';
    if (indice > this.etapaLiberada()) return 'bloqueada';
    return 'aguardando';
  }

  bloqueada(indice: number): boolean {
    return indice > this.etapaLiberada();
  }
}
